







































































































import { Component } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import GeneralLedgerAccountState from '@/components/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState.vue';
import GeneralLedgerAccountEdit from '@/components/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountEdit.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'GeneralLedgerAccountDetails', components: { GeneralLedgerAccountState, GeneralLedgerAccountEdit } })
export default class extends SaascadaVue {

    get generalLedgerAccount() {
        return GeneralLedgerAccountsModule.generalLedgerAccount;
    }

}
